import React from 'react'
import AgTechMetric from '@agtech/web/components/Metrics/AgTechMetric';
import SaleLotViewGrid from '../../lots/components/grid/SaleLotViewGrid';
import { useLotDataGetSaleLotDataQuery } from '@sales/data/lots/LotDataQueries';
import AgTechQueryLoadingSurface from '@agtech/core/data/queries/AgTechQueryLoadingSurface';
import LotManagementDialog from '../../lots/dialogs/LotManagementDialog';

export const SaleOverviewPage = () => {
    const saleOverviewPageQuery = useLotDataGetSaleLotDataQuery();

    return (
        <AgTechQueryLoadingSurface query={saleOverviewPageQuery}>
            {(saleData) => {
                const saleBidders = Object.values(saleData.bidders);
                const saleLots = Object.values(saleData.lots);

                return (
                    <div className='stretched column-based flex'>
                        <div id='sale-overview-lot-grid' className='flexed area-left flex'>
                            <SaleLotViewGrid />
                        </div>
                        <div className='vertical-pane row-based area-right w-[240px] flex'>
                            <div id='sale-overview-registered-bidders'>
                                <AgTechMetric header='Registered Bidders' value={saleBidders.length.toString()} />
                            </div>
                            <div id='sale-overview-lots-in-sale'>
                                <AgTechMetric header='Lots In Sale' value={saleLots.length.toString()} />
                            </div>
                            <div id='sale-overview-lots-sold'>
                                <AgTechMetric header='Lots Sold' value={saleLots.filter(lot => !!lot.purchasePrice).length.toString()} />
                            </div>
                            <div className='flexed flex' />
                            <div id='sale-overview-manage-lots'>
                                <LotManagementDialog.Button classes='button-block button-highlight w-full' />
                            </div>
                        </div>
                    </div>
                )
            }}
        </AgTechQueryLoadingSurface>
    )
}
